import {
  API_ENDPOINT,
  useClientApiV1VouchersIdFreeDeleteMutation,
} from '../../../../../../resources/@types/courseSchema';

export function useClientApiVouchersIdFreeDeleteMutation(
  { voucherId }: { voucherId: string | number },
  options?: Parameters<typeof useClientApiV1VouchersIdFreeDeleteMutation>[0]['options'],
) {
  return useClientApiV1VouchersIdFreeDeleteMutation({
    url: API_ENDPOINT.CLIENT_V1_VOUCHERS_ID_FREE(`${voucherId}`),
    options,
  });
}
